export const CLEAR_CURRENT_PROFILE = 'CLEAR_CURRENT_PROFILE';
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE';
export const SERVING_SET_IS_INVALID_STUDENT_SELECTED =
  'SERVING_SET_IS_INVALID_STUDENT_SELECTED';
export const SERVING_SET_IS_OPEN_SYMBOL = 'SERVING_SET_IS_OPEN_SYMBOL';
export const SERVING_SET_SYMBOLS_IS_OPEN = 'SERVING_SET_SYMBOLS_IS_OPEN';
export const UPDATE_PROFILE_BALANCE = 'UPDATE_PROFILE_BALANCE';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_LAST_TRANSACTION_PROFILE = 'SET_LAST_TRANSACTION_PROFILE';
export const UPDATE_PROFILE_PREVIOUS_AMOUNT_PAID =
  'UPDATE_PROFILE_PREVIOUS_AMOUNT_PAID';
export const ADD_ITEM_TO_TRANSACTION = 'ADD_ITEM_TO_TRANSACTION';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/state/types.js